export const HeirsLifeExternalUrl = process.env.REACT_APP_LIFE_URL;
export const HeirsDashboardUrl = process.env.REACT_APP_DASHBOARD_URL;
export const HeirsFetchPostsUrl = process.env.REACT_APP_DATABASE_URL;
export const HeirsEmailUrl = process.env.REACT_APP_EMAIL_URL;
export const HeirsWordPressUrl = "https://heirs.azurewebsites.net/";
